export function getArrayWithItemInTop<T>(arr: T[], index: number) {
  if (!arr) return [] as T[];

  const cloneArray = arr.slice();
  const [cuttedItem] = cloneArray.splice(index, 1);

  cloneArray.unshift(cuttedItem);
  return cloneArray;
}
